import { useEffect } from "react";

import type { OperationResult } from "./types";
import {
  isNullValueErrorDerivedFromOtherError,
  useRequestErrorTracker,
} from "./useErrorTracker";

const NOT_DEFINED = "NOT_DEFINED";
const HTTP_CODE_NOT_DEFINED = 418;

const useLogFrontendApiError = <ClientResult, ClientErrorResult>(
  result: OperationResult<ClientResult, ClientErrorResult>,
  errorCodes?: Array<string>,
  namespace?: string,
) => {
  const logRequestError = useRequestErrorTracker(namespace);
  const { errors, httpStatusCode, operationName } = result || {};

  useEffect(() => {
    if (Array.isArray(errors) && errors?.length) {
      errors.forEach((error) => {
        if (
          (!errorCodes ||
            !error.extensions?.errorCode ||
            errorCodes.includes(error.extensions?.errorCode)) &&
          !isNullValueErrorDerivedFromOtherError(
            errors,
            error.extensions?.errorCode,
          )
        ) {
          logRequestError({
            blockableFlow: false,
            errorMessage: error.message,
            edoErrorCode: error.extensions?.errorCode || NOT_DEFINED,
            responseHttpCode: httpStatusCode || HTTP_CODE_NOT_DEFINED,
            graphqlOperationName: operationName || NOT_DEFINED,
          });
        }
      });
    }
  }, [errors, httpStatusCode, errorCodes, operationName, logRequestError]);
};

export default useLogFrontendApiError;
